import { Navigate, Outlet } from 'react-router-dom';
import { selectIsAuthenticated, useAppSelector } from '@doccareplus/kernel/application';

// Portal gate: authenticated patients only. Unlike the clinic guard there is no clinic-context or
// phone-verification check — a portal account's phone is confirmed at OTP signup, and profile selection
// (PatientPortalLink) happens inside the app, not as an auth precondition.
export function ProtectedRoute() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
